module.exports = "/_next/static/images/help-bg-mobile-7871593b8cfdec3e0bdb9c9daca3ba73.svg";